<script>
  import Tailwind from './Tailwind.svelte';
  import AreaCalendar from './components/AreaCalendar.svelte';
  import { getLocaleFromNavigator, init as initLocalization, isLoading as langLoading, locale, register } from 'svelte-i18n';
  import { getConfig } from '@app/config';

  const { defaultLanguage } = getConfig().site;
  /*
   * Setup the localization here because we need the message loaded
   * before rendering anything.
   */
  register('fi', () => import('./i18n/fi.json'));
  register('en', () => import('./i18n/en.json'));

  initLocalization({
    fallbackLocale: 'fi',
    initialLocale: defaultLanguage
  });
</script>
<Tailwind/>
{#if !$langLoading}
  <AreaCalendar></AreaCalendar>
{:else}
Loading...
{/if}

<style></style>
